import { useMemo } from 'react';
import { useFormats, useRaceTypes } from '@/features/reference/useReference';
import type { FormatRef } from '@/api/referenceService';

const NON_SCALABLE_RACE_TYPES = ['GEN', 'BEGINNER'];

export interface ScalableFormat extends FormatRef {
  optionLabel: string;
}

export const useScalableFormats = (): ScalableFormat[] => {
  const { data: formats = [] } = useFormats();
  const { data: raceTypes = [] } = useRaceTypes();

  return useMemo(() => {
    const byId = new Map(raceTypes.map((rt) => [rt.id, rt]));
    return formats
      .filter((f) => !NON_SCALABLE_RACE_TYPES.includes(byId.get(f.raceTypeId)?.identifier ?? ''))
      .map((f) => {
        const raceType = byId.get(f.raceTypeId);
        return { ...f, optionLabel: raceType ? `${raceType.label} · ${f.label}` : f.label };
      });
  }, [formats, raceTypes]);
};
